import { api } from '../api';

const unwrap = (r) => r.data?.data ?? r.data;

export default {
  list:   (params)   => api.get('/v1/surveys', { params }).then(unwrap),
  get:    (id)       => api.get(`/v1/surveys/${id}`).then(unwrap),
  create: (body)     => api.post('/v1/surveys', body).then(unwrap),
  update: (id, body) => api.patch(`/v1/surveys/${id}`, body).then(unwrap),
  remove: (id)       => api.delete(`/v1/surveys/${id}`).then(unwrap),

  publish: (id) => api.post(`/v1/surveys/${id}/publish`).then(unwrap),
  close:   (id) => api.post(`/v1/surveys/${id}/close`).then(unwrap),

  submitResponse: (id, body)   => api.post(`/v1/surveys/${id}/responses`, body).then(unwrap),
  responses:      (id, params) => api.get(`/v1/surveys/${id}/responses`, { params }).then(unwrap),
  results:        (id)         => api.get(`/v1/surveys/${id}/results`).then(unwrap),
};
